<template>
  <div class="content">
    <van-nav-bar title="提现" @click-left="onClickLeft" @click-right="onClickRight">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" src="../../../assets/right_icon2.png" alt="">
      </template>
      <template #right>
        <img style="width: 4.93333vw;height: auto;display: inline-block;" src="../../../assets/card_home.png" alt="">
      </template>
    </van-nav-bar>
    <van-field
      readonly
      clickable
      right-icon="arrow"
      label-width="110"
      name="picker"
      :value="valueBusiness"
      label="提现至"
      placeholder="请选择银行"
      @click="showPicker = true"
    >
    </van-field>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="bank_name"
        @confirm="onConfirmBusiness"
        @cancel="showPicker = false"
      />
    </van-popup>
    <div class="input-box">
      <span>￥</span>
      <input class="input-c" @input="verifyClick" placeholder="请输入金额" v-model="inputNum" type="number" />
      <span class="all" @click="clickAll">全部</span>
    </div>
    <div class="hint">{{errMsg}}</div>
    <div class="list-box">
      <div class="item justify-align">
        <span>可提现</span>
        <span class="rt-txt">￥{{moneyNumber}}</span>
      </div>
      <div class="item justify-align">
        <span>最低提现</span>
        <span class="rt-txt">￥1</span>
      </div>
      <div class="item justify-align">
        <div class="f-y">
          手续费<van-icon color="#BCBCBC" name="info-o" />
          <div style="font-size: 2.66667vw;color: #BCBCBC;">万分之一(0.01%)，0.5元保底</div>
        </div>
        <span class="rt-txt" v-if="serveMoney != 0">￥{{serveMoney}}</span>
      </div>
<!--      <div class="item justify-align">-->
<!--        <strong>支付密码</strong>-->
<!--        <input id="pwd1" class="input-item default" placeholder="请输入密码" />-->
<!--      </div>-->
    </div>
    <div class="bottom-box justify-align">
      <div>

      </div>
      <div class="bottom-rt-box left-justifying">
        <div class="money-box">
          <div style="margin-bottom: 1.33333vw;"> 提现：￥{{inputNum}}</div>
          <div>服务费：￥{{serveMoney}}</div>
        </div>
        <van-button class="btn" :disabled="isBtnDisabled" @click="submitDeposit">确认提现</van-button>
      </div>

    </div>
<!--    <van-button style="margin: 2.66667vw;" @click="submitWalletPush1">查询余额</van-button>-->
<!--    输入密码弹框-->
    <van-popup round v-model="showContent" :close-on-click-overlay="false">
      <div class="popup-box">
        <span class="close-icon"><van-icon name="cross" @click="showContentHide" /> </span>
        <div class="top-box"><span>请输入密码</span></div>
        <div class="tx-box">
          <span>提现</span>
          <div class="popup-number"><span style="font-weight: bold;">￥</span>{{inputNum}}</div>
        </div>
        <div class="popup-money-box">
          <div class="item-popup justify-align">
            <span>服务费</span> <div>￥{{serveMoney}}</div>
          </div>
          <div class="item-popup justify-align">
            <span>密码</span>
            <div class="input-div">
              <input id="pwd1" class="input-item default popup-input" placeholder="请输入密码" type="text" />
            </div>
          </div>
        </div>
        <van-button @click="submitWalletPush" :disabled="disabledWallet" round type="info" style="width:70%;height: 10.66667vw;line-height: 1.33333vw;margin: 2.66667vw auto;display: block;">提现</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {getPlugRandomKey, getWalletBank,walletPush,walletPushTransfer,walletPushOld, walletBalance,walletBalanceTest} from '@/api/wallet'
import "@/utils/initKeyBoard"
export default {
  name: "withdrawDeposit",
  data(){
    return {
      inputNum:'',
      valueBusiness: '',
      columns: [],
      showPicker: false,
      valueBusinessId: '',
      moneyNumber: 100,
      errMsg: '',
      isBtnDisabled: false,
      showContent:false,
      serveMoney: 0,
      pwd1:'',
      plugRandomKey: '', // 随机因子
      serviceCharge: 0.01,
      isWithdraw:true, // 大于1元才能提现 true可以提
      disabledWallet:false, // 提现弹框按钮是否点击
      lastTransferInfo:'', // 上次提现记录
      bank_id: '',
      userInfo: ''
    }
  },
  mounted() {
    let rsaPublicKey = window.g.rsaPublicKey // rsa 公钥。 demo 中的 RSA 公钥是测试公钥。上生产时需更换为生产公钥。
    // if (process.env.VUE_APP_MODE === 'development' || process.env.VUE_APP_MODE === 'test') {
    //   // 开发环境下的执行操作
    //   rsaPublicKey = '30818902818100ac7916eeb5cc45b22e8a20ebb2cb11ac6b76678564300b70c3f09f8c0cb92076499556c2d60fa02a78d2d3d94a559ee5f65f5f89a94da88e5cade3bf6a412e4832d7380958fee0c9fe959a1e4c45c8c037a04f693210bb76fa0a3a9dbf3bee803e1365572b03848a7aa2e547257e5a8461073fd15b68b381f5bd76ec7fbc4d230203010001'
    //
    //   console.log('test环境')
    // } else {
    //   // 生产环境下的执行操作
    //   rsaPublicKey = '3082010a0282010100b219d36d00538fe607dfb5d366d6fd4205ba70710cf65a9f192b36193a5ecc6504ca30f3a97b594be744e4480a410220882b9b16f08ca780f05872c4297160bdf76f327e085634dd0b217681e5a55a005c3efb8834a71dfb268b816acce59143eba474f86acc9f86dc5af287e380b9c709ac4018597b621f5c08ccbecce3687a0d81c86d7ef3acc1eb8e46da52788607c7571313b476c50512e9eeab51829d23723d12b6d51816f3ccc7d37c66a6e92939ae5fe9f1b43fd0516b6fff72e3b09eb9c3b241dff81cbf2b8b3160ce0caf2ac705b2786abeac8a7c704664ef3bac8cd206c598b662582076f743893087416aff2ea05dca231b95133290e79ed6505d0203010001'
    //   console.log('生产环境')
    // }
    // console.log(window.g.rsaPublicKey)

    this.rsaPublicKey = rsaPublicKey
    // this.$nextTick(() => {
    //   this.pass1();
    // })
  },
  created() {
    this.getUser()
  },
  beforeDestroy: function() {
    console.log('beforeDestroy')
    window.document.body.style.height= 'auto'
  },
  methods: {

    async getUser () {
      const res = await this.$Http.getInfo()
      if (res.code == 200){
        const info = res.data;
        this.userInfo = info
        if(info.balance != null){
          this.moneyNumber = info.balance
          if (this.moneyNumber >= 1){ //大于等于1才能提现
            this.isWithdraw = true
            console.log('is',this.isWithdraw)
          } else {
            this.isWithdraw = false
            console.log('is,false',this.isWithdraw)
          }
        }
        // console.log('res',res)
        this.$store.commit('setUserInfo', info)
        this.getWalletPushTransfer()
        this.getPlugRandomKeyDes()//密码控件只能使用一次


      } else {
        this.$router.push('/');
      }
    },
    getWalletPushTransfer(){ // 查询上次提现记录
      walletPushTransfer().then(res=>{
        if(res.code == 200)
        {

          this.lastTransferInfo = res.data
          console.log('res',res.data)
          let data = res.data
          if (JSON.stringify(data) == "{}"){
            this.showContent = false

          }else { // 有记录
            this.showContent = true
            this.inputNum = res.data.amount
            this.bank_id = res.data.bank_id
            this.verifyClick()
            this.$nextTick(() => {
              this.pass1();
            })
          }
          this.getBankList()
        }
        else
        {
          this.$toast(res.message)
        }
      })
    },
    verifyClick(){ // 计算服务费
      // console.log('输入金额',this.inputNum)
      // console.log('余额', this.moneyNumber)
      // this.moneyNumber = 5510
      if (parseInt(this.inputNum) > parseInt(this.moneyNumber)){
        this.errMsg = '输入金额超过余额'
        this.isBtnDisabled = true
      } else {
        this.errMsg = ''
        this.isBtnDisabled = false

        if (this.inputNum != ''){
          let servePrice = 0
          let discount = (parseFloat(this.serviceCharge)/100) // 服务费0.01%  手续费万分之一，0.5元保底
          // console.log('di',discount)
          let b = (parseFloat(this.inputNum)*discount)
          let y = String(b).indexOf(".") + 1;//获取小数点的位置
          if(y > 0) { // 判断是否有小数
            // alert("这个数字是小数，有" + ',' + "位小数");
            let s = this.getnum(b) // 保留2位小数
            servePrice = s
          } else {
            // alert("不是小数");
            servePrice = b +'.00' // 消费总额
          }
          if (servePrice >= 0.5){
            this.serveMoney = servePrice
          }else {
            this.serveMoney = 0.5
          }
          // console.log('serve',this.serveMoney)
        }


      }
    },
    clickAll(){
      if (this.isWithdraw){ // 大于等于1元可提现
        this.inputNum = this.moneyNumber
        let discount = (parseFloat(this.serviceCharge)/100)
        console.log('serve',discount)
        let b = (parseFloat(this.inputNum)*discount)
        let y = String(b).indexOf(".") + 1;//获取小数点的位置
        if(y > 0) { // 判断是否有小数
          // alert("这个数字是小数，有" + ',' + "位小数");
          let s = this.getnum(b) // 保留2位小数
          this.serveMoney = s
        } else {
          // alert("不是小数");
          this.serveMoney = b +'.00' // 消费总额
        }
      }else {
        this.$toast('最低提现金额1元')
      }

    },
    getnum(num){
      num = String(num)
      return num.substring(0,num.indexOf(".")+3);
    },
    getBankList(){
      getWalletBank().then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data)
          let arr = res.data
          if (arr.length == 0){
            this.$dialog.alert({
              title: '提示',
              message: '请添加银行卡'
            }).then(() => {
              // on close
              // this.$router.push({path: 'myCard'})
              this.$router.go(-1);
            });
          } else {
            this.columns = res.data
            this.valueBusiness = res.data[0].bank_name
            this.valueBusinessId = res.data[0].id
          }

        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    onConfirmBusiness(value) {
      console.log('1',value)
      this.valueBusiness = value.bank_name;
      this.valueBusinessId = value.id
      this.showPicker = false;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      this.$router.push('/');
    },
    getPlugRandomKeyDes(){ // plugRandomKey(随机数)
      getPlugRandomKey().then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data)
          this.plugRandomKey =  res.data.msgBody.list[0].plugRandomKey
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    getWalletBalance(miwen){ // 查询钱包余额
      const data = {
        encryptPwd: miwen, // 开户时的支付密码
        plugRandomKey: this.plugRandomKey,
      }
      walletBalance(data).then( res =>{
        if(res.code == 200)
        { // 验证密码正确才调提现接口
          this.submitWalletPushPort(miwen)
        }else {
          this.$dialog.alert({
            title: '提示',
            message: res.message,
          }).then(() => {
            // on close
            this.showContent = false
            this.isBtnDisabled = false
            this.disabledWallet = false
            this.inputNum = ''
            document.getElementById('pwd1').value = ''
            this.getUser()
          });
        }
      })
    },

    submitWalletPush(){ // 弹框提现确定按钮
      var pwd = document.getElementById('pwd1').value
      if (pwd == ''){
        this.$toast('密码不能为空')
        return false;
      } else {
        this.disabledWallet = true // 防止多次 按钮不能
        passGuard1.setRandKey(this.plugRandomKey);
        //获取密文
        let miwen = passGuard1.getOutput();
          this.getWalletBalance(miwen) // 验证密码是否正确


      }
    },
    submitWalletPush1(){ // 测试查询余额

        const data = {
          wallet_id: this.userInfo.wallet_id, // 开户时的支付密码
        }
        walletBalanceTest(data).then( res =>{
          if(res.code == 200)
          { // 验证密码正确才调提现接口
            // this.submitWalletPushPort(miwen)
            // this.$toast(res.message)
          }else {
            // this.$dialog.alert({
            //   title: '提示',
            //   message: res.message,
            // }).then(() => {
            //   // on close
            // });
          }
        })
    },
    submitWalletPushPort(miwen){ // 提现接口
      // 判断是否有上一次未提现记录
      let dataLast = this.lastTransferInfo
      if (JSON.stringify(dataLast) == "{}"){ // 没有
        let id = this.valueBusinessId
        const data = {
          amount: this.inputNum,
          encryptPwd: miwen, // 开户时的支付密码
          plugRandomKey: this.plugRandomKey,
        }
        walletPush(id,data).then(res=>{
          if(res.code == 200)
          {
            this.$dialog.alert({
              title: '提示',
              message: res.message,
            }).then(() => {
              // on close
              this.$router.go(-1);
            });
          }
          else
          {
            this.$dialog.alert({
              title: '提示',
              message: res.message,
            }).then(() => {
              // on close
              this.showContent = false
              this.isBtnDisabled = false
              this.disabledWallet = false
              this.inputNum = ''
              document.getElementById('pwd1').value = ''
              this.getUser()
            });
          }
        })
      }else { // 有记录
        let orderId = this.lastTransferInfo.id
        const data = {
          encryptPwd: miwen, // 开户时的支付密码
          plugRandomKey: this.plugRandomKey,
        }
        walletPushOld(orderId,data).then(res=>{
          if(res.code == 200)
          {
            // console.log('res',res.data)
            this.$dialog.alert({
              title: '提示',
              message: res.message,
            }).then(() => {
              // on close
              this.$router.go(-1);
            });
          }
          else
          {
            this.$dialog.alert({
              title: '提示',
              message: res.message,
            }).then(() => {
              // on close
              this.showContent = false
              this.isBtnDisabled = false
              this.disabledWallet = false
              this.inputNum = ''
              document.getElementById('pwd1').value = ''
              this.getUser()
            });
            // this.$toast(res.message)
          }
        })

      }
    },
    pass1() {
      let that = this;
      window.passGuard1 = new passGuard(
        {
          //   "mappurl": "./send_mapping.jsp",//此处为了前端演示而屏蔽了，正常开发中需要此参数，该地址由后台人员提供
          "fixed": "H5fixed",//当fixed接口添加时，代表该输入框在fixed覆盖层上且覆盖层的ID为接口的值(在demo中覆盖层ID为"H5fixed")
          "maxLength": 12, // 最大输入长度
          "regExp1": "[\\S\\s]", // 输入过程限制的正则
          "regExp2": "[\\S\\s]{6,12}",
          "displayMode":0, // 显示形式,0:星号;1:明文,默认值0
          "callBack": that.callBack1, //成功回调
          "errorCallBack": that.errorCallBack1, //失败回调
          "focus": that.inputFocus1,//H5键盘获取焦点回调
          "blur": that.inputBlur1,//H5键盘失去焦点回调
          "rsaPublicKey": that.rsaPublicKey // rsa公钥
        });
      //初始化密码卫士,绑定键盘对象。数字参数：0代表全键盘，1代表数字键盘
      window.passGuard1.generate("pwd1", window.kb, "passGuard1", 1);
    },
    callBack1() {
      console.log("callBack");
    },
    errorCallBack1() {
      // console.log("errorCallBack");
    },
    inputFocus1() { // 获取焦点时的事件
      // console.log("获取焦点时的事件inputFocus");
    },
    inputBlur1() { // 获取焦点时的事件
      // console.log("输入框失去焦点inputBlur");
    },
    callBack2() {
      // console.log("callBack");
    },
    submitDeposit() {
      if (this.isWithdraw){
        if (this.inputNum == ''){
          this.$toast('请输入金额')
          return false
        } else {
          this.isBtnDisabled = true
          this.showContent = true
          this.$nextTick(() => {
            this.pass1();
          })

        }
      }else {
        this.$toast('最低提现金额1元')
      }

    },
    showContentHide(){
      let dataLast = this.lastTransferInfo
      if (JSON.stringify(dataLast) == "{}") { // 没有
        this.isBtnDisabled = false
        this.showContent = false
      }else {
        this.showContent = true
        this.$router.go(-1);
      }

    }
  }
}
</script>

<style lang="scss" scoped>
input::-webkit-input-placeholder {
          /* placeholder颜色  */
          color: #aab2bd;
         /* placeholder字体大小  */
         font-size: 30px;
        /* placeholder位置  */
         text-align: right;font-weight: normal;text-align: center;
    }
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-cell{
  font-size: 30px;color: #282828;
}
.hint{
  color: #fa1017;padding-bottom: 10px;background: #FFFFFF;text-align: center;
}
.input-box{
  font-size: 48px;font-weight: 800;
  color: #282828;padding: 40px 20px;background: #FFFFFF; top-border:1px solid #ccc;
  input{
    width: 80%;border: none;text-align: center;font-size: 60px;
  }
  .all{
    color: #66BF4E;font-size: 24px;font-weight: normal;
  }
}
.list-box{
  background: #FFFFFF;padding: 0 24px;margin-top: 20px;
  .item{
    padding: 30px 0;border-bottom: 1px solid #EBEBEB;
    .f-y{
      text-align: left;
    }
    .rt-txt{
      font-size: 34px;font-weight: bold;
      color: #282828;
    }
  }
}
.bottom-box{
  position: fixed;bottom: 0;padding: 30px 0;
  width: 100%;left: 0;background: #ffffff;font-size: 22px;
  .money-box{
text-align: right;
  }
  .btn{
    width: 230px;
    height: 86px;line-height: 86px;font-size: 34px;
    background: #FDD80D;font-weight: bold;
    color: #282828;text-align: center;
    border-radius: 43px;margin-right: 20px;margin-left: 20px;
  }
}
.popup-box{
  padding: 30px 30px 30px;width: 500px;
  position: relative;
  .top-box{
    text-align: center;font-size: 30px;
  }
  .tx-box{
    text-align: center;font-weight: bold;font-size: 60px;padding: 40px 0 20px;
    border-bottom: 2px solid #F5F5F5;margin-bottom: 20px;
    .popup-number{
      margin-top: 20px;
    }
    span{
      font-size: 28px;font-weight: normal;
    }
  }
  .close-icon{
    position: absolute;left: 30px;top: 20px;font-size: 40px;
  }
  .popup-money-box{
    .item-popup {
      padding: 10px 0;
      span{
        color: #999;
      }
      div{
        width: 80%;text-align: right;
      }
      .input-div{
        overflow: hidden;
      }
      .popup-input{
       height: 70px;line-height: 70px;text-align: right;padding: 0 20px;border:none;
        border-bottom: 2px solid #bbbbbb;
        text-align: right;margin-left: 20px;
      }
    }
  }
}
/deep/.van-overlay{
  z-index: 1!important;
}
/deep/.van-popup--center{
  top: 30%;
}
</style>
